export default "__VITE_ASSET__Kqb863e8__"